import React, {Component} from "react";
import {GoogleOAuthProvider, GoogleLogin} from '@react-oauth/google';
import * as Sentry from "@sentry/browser";

export class LoginWithGoogle extends Component {
    constructor(props) {
        super(props);

        this.responseOnSuccess = this.responseOnSuccess.bind(this);
    }

    responseOnFailure(response) {
        alert("There was a problem with the Google login process. Please try again later.");
        Sentry.captureException(response)
    }

    responseOnSuccess(credentialResponse) {
        if (credentialResponse.credential) {
            this.props.onGoogleLoginSucessful({
                token_id: credentialResponse.credential,
            });
        } else {
            this.responseOnFailure(credentialResponse);
        }
    }

    render() {
        return (
            <GoogleOAuthProvider clientId="330373907640-iug7bu3cqe277t7faqckn34uu16vts0l.apps.googleusercontent.com">
                <div className="login-buttons mt-5">
                    <GoogleLogin 
                        onSuccess={this.responseOnSuccess}
                        onError={this.responseOnFailure}
                        useOneTap
                        locale="es"
                    />
                </div>
            </GoogleOAuthProvider>
            
        );
    }

}
